var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditpencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_20297_68897)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 23,
    width: 31.5858,
    height: 31.5861,
    rx: 4,
    fill: "#E3E8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 34.5861L35 42.5861V46.5861L39 46.586L47 38.586M43 34.5861L45.8686 31.7174L45.8704 31.7157C46.2652 31.3208 46.463 31.123 46.691 31.0489C46.8919 30.9837 47.1082 30.9837 47.3091 31.0489C47.5369 31.123 47.7345 31.3205 48.1288 31.7149L49.8686 33.4547C50.2646 33.8507 50.4627 34.0488 50.5369 34.2771C50.6022 34.4779 50.6021 34.6943 50.5369 34.8951C50.4628 35.1233 50.265 35.3211 49.8695 35.7166L49.8686 35.7174L47 38.586M43 34.5861L47 38.586",
    stroke: "#2D53DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_20297_68897",
    x: 0,
    y: 0,
    width: 85.5858,
    height: 85.5859,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_20297_68897"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_20297_68897",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditpencil);
export default __webpack_public_path__ + "static/media/editpencil.944448326044082d3a8aa375a7bf0b1d.svg";
export { ForwardRef as ReactComponent };